import goodsItem from './goodsItem';
import videoItem from './videoItem';
import articleItem from './articleItem';
import commentItem from './commentItem';
import dataController from './dataController';
import errorView from './error-view';
import emptyView from './empty-view';
import loadingView from './loading-view';
import yList from './list';

module.exports = {
  goodsItem,
  videoItem,
  articleItem,
  commentItem,
  dataController,
  errorView,
  emptyView,
  loadingView,
  yList
}



// WEBPACK FOOTER //
// ./src/components/app/index.js